import product_list from './product_list';
import product_detail from './product_detail';
import promotion_page from './promotion_page';
import order_detail from './order_detail';
import order_confirm from './order_confirm';
import category from './category';
import cart from './cart';
import checkout from './checkout';
import home from './home';
import tag_products from './tag_products';
import advanced_page from './advanced_page';
import advanced_page_section from './advanced_page_section';
import text_page from './text_page';
import post_detail from './post_detail';
import posts from './posts';
import post_category_detail from './post_category_detail';
import form_page from './form_page';
import redeem_gift from './redeem_gift';
import sign_up from './sign_up';
import sign_in from './sign_in';
import customer_orders from './customer_orders';
import customer_messages from './customer_messages';
import customer_wishlist from './customer_wishlist';
import customer_user_credits from './customer_user_credits';
import customer_member_points from './customer_member_points';
import customer_profile from './customer_profile';
import customer_coupons from './customer_coupons';
import eventMetaMap from '../../../constants/slEventBusEventNames';
import { transformCartEventData } from './transform';

// Schema for all supported pages
const all = {
  functions: [
    {
      name: 'getMerchantId',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'merchantId',
      },
    },
    {
      name: 'getLoadedCurrency',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'loadedCurrency',
      },
    },
    {
      name: 'getCurrentPageIdentifier',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'pageIdentifier',
      },
    },
    {
      name: 'getCurrentThemeKey',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'themeKey',
      },
    },
    {
      name: 'getLoadedLanguage',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'loadedLanguage',
      },
    },
    {
      name: 'getCookieConsent',
      type: 'angularFunc',
      options: {
        source: 'cookieConsentService',
        key: 'getAllCookieConsents',
      },
    },
    // Metafield Values
    {
      name: 'getMetafieldValues',
      type: 'nativeFunc',
      options: {
        source: 'MetafieldValuesService',
        key: 'getMetafieldValues',
        includeAppId: true,
      },
    },
  ],
  events: [
    {
      incomingEvent: eventMetaMap.general.currencyChanged,
      sdkEvent: 'currency.changed',
    },
    {
      incomingEvent: 'cart.itemAdded',
      sdkEvent: 'cart.update',
      transform: (data) => transformCartEventData(data),
    },
    {
      incomingEvent: 'cart.itemUpdated',
      sdkEvent: 'cart.update',
      transform: (data) => transformCartEventData(data),
    },
    {
      incomingEvent: 'cart.itemRemoved',
      sdkEvent: 'cart.update',
      transform: (data) => transformCartEventData(data),
    },
  ],
};

// Should use page identifier as the key
export default {
  all,
  cart,
  category,
  checkout,
  product_list,
  product_detail,
  promotion_page,
  order_detail,
  order_confirm,
  home,
  tag_products,
  advanced_page,
  advanced_page_section,
  text_page,
  post_detail,
  posts,
  post_category_detail,
  form_page,
  redeem_gift,
  sign_up,
  sign_in,
  // Keys below must match the page_identifier string exactly, slash included.
  'customer/orders': customer_orders,
  'customer/messages': customer_messages,
  'customer/wishlist': customer_wishlist,
  'customer/user_credits': customer_user_credits,
  'customer/member_points': customer_member_points,
  'customer/profile': customer_profile,
  'customer/coupons': customer_coupons,
};
